(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope','$timeout','$location', '$state', 'Auth', 'Principal', 'ENV', 'LoginService', 'EventDashboard', '$scope'];

    function NavbarController ($rootScope,$timeout, $location, $state, Auth, Principal, ENV, LoginService, EventDashboard, $scope) {
        var vm = this;

        vm.navCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = ENV === 'prod';
        vm.login = login;
        vm.logout = logout;
        vm.$state = $state;
        vm.eventDashboards = [];
        vm.hasAnyAuthority = hasAnyAuthority;

        // Manual saves and assistant creation refresh the menu without reloading the application.
        var unregisterDashboardUpdate = $rootScope.$on('wamasysApp:eventDashboardUpdate', loadEventDashboards);
        $scope.$on('$destroy', unregisterDashboardUpdate);

        function loadEventDashboards() {
            if (!hasAnyAuthority(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_EVT_EDIT', 'ROLE_EVT_READ_ONLY'])) {
                return;
            }
            EventDashboard.navbar(function(result) {
                vm.eventDashboards = result;
                $timeout(function() {
                    $rootScope.$broadcast('refreshSmartMenu', 'refresh');
                });
            });
        }

        function login () {
            LoginService.open();
        }

        function logout () {
            Auth.logout();
            $state.go('home');
        }

        function hasAnyAuthority(authorities) {
            var userAuthorities = vm.user && vm.user.authorities ? vm.user.authorities : [];
            for (var i = 0; i < authorities.length; i++) {
                if (userAuthorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }
            return false;
        }
        
        vm.user = {} ;
        Principal.identity().then(function(account) {
        	  vm.user = account;
              $timeout(function() {
                  $rootScope.$broadcast('refreshSmartMenu','refresh');
              });

 			 if(vm.user.listDashboardKibana && typeof vm.user.listDashboardKibana === 'string'){
        		 try {
        			 vm.user.listDashboardKibana = JSON.parse(vm.user.listDashboardKibana);
        			 $timeout(function() {
        				$rootScope.$broadcast('refreshSmartMenu','refresh');
        			 });
        			 
         	    } catch (e) {
         	    	console.log(e);
         	    } 
			 }

             loadEventDashboards();
 			 
        });
    }
})();
